import { render, staticRenderFns } from "./VendorProfileComp.vue?vue&type=template&id=0135a1da"
import script from "./VendorProfileComp.vue?vue&type=script&lang=ts"
export * from "./VendorProfileComp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports